/* eslint-disable @next/next/no-img-element */
import { KatIcon } from '@amzn/katal-react';
import React from 'react';
import {
  ReactEditor, RenderElementProps, useSelected, useSlate,
} from 'slate-react';
import { ImageElement as ImageElementType } from 'src/types/CustomSlateTypes';
import { Transforms } from 'slate';

export type ImageElementProps = {
  element: ImageElementType;
} & RenderElementProps;

const ImageElement = ({ element, children, attributes }: ImageElementProps) => {
  const editor = useSlate();
  const selected = useSelected();

  return (
    <div {...attributes} draggable className="mb-4">
      {children}
      <div className="relative">
        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
        <img
          src={element.url}
          alt="Uploaded Image"
          className={`min-w-[5rem] max-w-full ${selected ? 'outline outline-4 outline-kat-eastern' : ''}`}
        />
        {selected && (
          <button
            data-testid="delete-button"
            type="button"
            className="absolute top-2 cursor-pointer rounded border-0 bg-kat-white px-0 pt-1 pb-0 text-black ltr:left-2 rtl:right-2"
            onClick={() => {
              Transforms.removeNodes(editor, {
                at: ReactEditor.findPath(editor, element),
              });
            }}
          >
            <KatIcon name="trash" size="small" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ImageElement;
